import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Métodos de pago',
  fields: {
    hidden_payment_methods: {
      label: 'Métodos de pago ocultos',
    },
    has_online_payments: {
      label: 'Tiene pagos en línea',
    },
    has_paypal_upcharge: {
      label: 'Recargo del 3,5% extra en transacciones de PayPal',
    },
    has_cash_payments: {
      label: 'Tiene pagos en efectivo',
    },
    has_occ_cash_payments: {
      label: 'Pagos en efectivo del Call Center habilitados',
    },
    has_in_store_card_payments: {
      label: 'Tiene pagos con tarjeta en tienda',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Etiquetar pagos en efectivo como «Factura»',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Tarjeta',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Débito SEPA',
    [PaymentMethods.CASH]: 'Efectivo',
    [PaymentMethods.BACS_DEBIT]: 'Débito Bacs',
    [PaymentMethods.PAY_BY_BANK]: 'Pago por banco',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Recogida',
    [ORDER_METHODS.delivery]: 'Entrega a domicilio',
    [ORDER_METHODS.room_service]: 'Servicio de habitación/mesa',
  },
  modals: {
    confirmation: {
      title: '¿Estás seguro?',
      description:
        'Una vez confirmado, los pagos en línea estarán <strong>{{onlineState}}</strong>, los pagos en efectivo estarán <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'desactivado',
    on: 'activado',
  },
  buttons: {
    save: 'Guardar',
    configure_online_payments: 'Configurar pagos en línea',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
